import md5 from "./md5";

export default function gravatarUrl(email, size = 200) {
  const hash = md5((email || "").trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=mp`;
}
